import { isIdXboxGameInformationGameExpectationsValid } from "../../../../helpers/formValidation";
import {
  GameInformationGameExpectationsDataType,
  SubFormsDataTypes,
} from "../../../../models/forms";
import { DataFilterResult, IDataFilter } from "../dataFilter";

export const GameExpectationsDataFilter: IDataFilter = {
  validate: async (data: SubFormsDataTypes | undefined): Promise<DataFilterResult> => {
    const gameExpectationsData = data as GameInformationGameExpectationsDataType;
    if (!gameExpectationsData) {
      return { result: true };
    }

    const validSchema = await isIdXboxGameInformationGameExpectationsValid(gameExpectationsData);
    return { result: validSchema };
  },
};
